import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DatosCompartidosService } from "../service/datos-compartidos.service";
import { environment } from "../../environments/environment";
@Injectable()
export class LoginResolve implements Resolve<any> {

    constructor(private datosCompartidosService: DatosCompartidosService,
        private router: Router) {
    }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<any> {

        let user: any = undefined;

        if(document.location.href.includes("admin")){
            user = JSON.parse(localStorage.getItem('activeUserWebAdmin'));
        }else if(document.location.href.includes("intranet")){
            user = JSON.parse(localStorage.getItem('activeUserIntranet'));
        }
        //console.log(user);
        if (user!= undefined) {
            this.router.navigate(['/default/']);
            return;
        }

    }
}
